import { createRouter, createWebHistory } from "vue-router";

import TestPage from "./views/TestPage.vue";
// import Home from "./views/Home.vue";
import HomePage_Taoyuan from "./views/HomePage_Taoyuan.vue";
import HomePage_Activity from "./views/HomePage_Activity.vue";
import CatePage from "./views/CatePage.vue";
import Content from "./views/Content.vue";
import Profile from "./views/Profile.vue";
import Setting from "./views/Setting.vue";
import Management from "./views/Management.vue";
import Reported from "./views/Reported.vue"
import GroupProfile from "./views/GroupProfile.vue"
import PackContent from "./views/PackContent.vue"
import AccountInfo from "./views/Authorize/AccountInfo.vue"
import Binding_CheckAccount from "./views/Authorize/Binding_CheckAccount.vue"
import Binding_Choose from "./views/Authorize/Binding_Choose.vue"
import Activity_List from "./views/Activity/Activity_List.vue"
import Goodkid_Home from "./views/Activity/Goodkid_Home.vue"
import Activity_Info from "./views/Activity/Activity_Info.vue"
import Activity_InfoVer2 from "./views/Activity/Activity_InfoVer2.vue"
import Activity_GoodkidPreview2026 from "./views/Activity/Activity_GoodkidPreview2026.vue"
import Activity_Goodkid2026Test from "./views/Activity/Activity_Goodkid2026Test.vue"
import Activity_Goodkidtest_20260508 from "./views/Activity/Activity_Goodkidtest_20260508.vue"
import Activity_Test0522 from "./views/Activity/Activity_Test0522.vue"
import Activity_CloneTemplate from "./views/Activity/Activity_CloneTemplate.vue"
import Activity_Goodkid20260827 from "./views/Activity/Activity_Goodkid20260827.vue"
import Activity_Goodkid2026demo0612 from "./views/Activity/Activity_Goodkid2026demo0612.vue"
import Activity_MainvisualTest from "./views/Activity/Activity_MainvisualTest.vue"
import Activity_Goodkid2026 from "./views/Activity/Activity_Goodkid2026.vue"
import Activity_InfoGeneric from "./views/Activity/Activity_InfoGeneric.vue"
//import Test_Menu from "./views/Activity/Test_Menu.vue"
import Activity_CheckLogin from "./views/Activity/Activity_CheckLogin.vue"
import Activity_Data from "./views/Activity/Activity_Data.vue"
import MindMapHome from "./views/MindMapHome.vue"
import MindMap from "./components/MindMap.vue"
import Activity_CreateClass from "./views/Activity/Activity_CreateClass.vue"



const routes = [
  {
    path: "/testPage",
    name: "TestPage",
    component: TestPage,
    meta: { requiresAuth: false },
  },
  // {
  //   path: "/",
  //   name: "Home",
  //   component: Home,
  //   meta: { requiresAuth: false },
  // },
  {
    path: "/",
    name: "Home",
    component: HomePage_Taoyuan,
    meta: { requiresAuth: false,title: '桃園市HiTeach授權活動平台' },
  },
  {
    path: "/HomePage_Taoyuan",
    name: "HomePage_Taoyuan",
    component: HomePage_Taoyuan,
    meta: { requiresAuth: false },
  },
  {
    path: "/HomePage_Activity",
    name: "HomePage_Activity",
    component: HomePage_Activity,
    meta: { requiresAuth: false },
  },//HomePage_Activity
  {
    path: "/AccountInfo",
    name: "AccountInfo",
    component: AccountInfo,
    meta: { requiresAuth: false },
  },
  {
    path: "/Binding_CheckAccount",
    name: "Binding_CheckAccount",
    component: Binding_CheckAccount,
    meta: { requiresAuth: false },
  },
  {
    path: "/Binding_Choose",
    name: "Binding_Choose",
    component: Binding_Choose,
    meta: { requiresAuth: false },
  },  
  {
    path: "/Activity_List",
    name: "Activity_List",
    component: Activity_List,
    meta: { requiresAuth: false },
  }, 
  {
    path: "/Goodkid_Home",
    name: "Goodkid_Home",
    component: Goodkid_Home,
    meta: { requiresAuth: false,title: '全國閱讀好小子學藝競賽' },
  }, 
  {
    path: "/goodkid",
    name: "goodkid",
    component: Goodkid_Home,
    meta: { requiresAuth: false,title: '全國閱讀好小子學藝競賽'  },
  },
  {
    path: "/Activity_Info",
    name: "Activity_Info",
    component: Activity_Info,
    meta: { requiresAuth: false,title: '全國閱讀好小子學藝競賽' },
  },
  {
    path: "/goodkid2024",
    name: "goodkid2024",
    component: Activity_Info,
    meta: { requiresAuth: false,title: '全國閱讀好小子學藝競賽'  },
  },
  {
    path: "/Activity_InfoVer2",
    name: "Activity_InfoVer2",
    component: Activity_InfoVer2,
    meta: { requiresAuth: false,title: '' },
  },
  // {
  //   path: "/Test_Menu",
  //   name: "Test_Menu",
  //   component: Test_Menu,
  //   meta: { requiresAuth: false,title: '' },
  // },
  {
    path: "/goodkid2025",
    name: "goodkid2025",
    component: Activity_InfoVer2,
    meta: { requiresAuth: false,title: '2025 全國閱讀好小子學藝競賽' },
  },
  {
    path: "/goodkid2026_preview",
    name: "goodkid2026_preview",
    component: Activity_GoodkidPreview2026,
    meta: { requiresAuth: false,title: '2026 全國閱讀好小子學藝競賽' },
  },
  {
    path: "/goodkid2026test",
    name: "goodkid2026test",
    component: Activity_Goodkid2026Test,
    meta: { requiresAuth: false,title: '2026 全國閱讀好小子學藝競賽' },
  },
  {
    path: "/goodkidtest_20260508",
    name: "goodkidtest_20260508",
    component: Activity_Goodkidtest_20260508,
    meta: { requiresAuth: false,title: '2026 全國閱讀好小子學藝競賽' },
  },
  {
    path: "/test0522",
    name: "test0522",
    component: Activity_Test0522,
    meta: { requiresAuth: false,title: '2026 全國閱讀好小子學藝競賽' },
  },
  {
    path: "/activity_clone_template",
    name: "activity_clone_template",
    component: Activity_CloneTemplate,
    meta: { requiresAuth: false,title: '2026 全國閱讀好小子學藝競賽' },
  },
  {
    path: "/goodkid20260827",
    name: "goodkid20260827",
    component: Activity_Goodkid20260827,
    meta: { requiresAuth: false,title: 'Willa_測試活動' },
  },
  {
    path: "/goodkid2026demo0612",
    name: "goodkid2026demo0612",
    component: Activity_Goodkid2026demo0612,
    meta: { requiresAuth: false,title: '2026 全國閱讀好小子學藝競賽' },
  },
  {
    path: "/mainvisual_test",
    name: "mainvisual_test",
    component: Activity_MainvisualTest,
    meta: { requiresAuth: false,title: '2026 全國閱讀好小子學藝競賽' },
  },
  {
    path: "/goodkid2026",
    name: "goodkid2026",
    component: Activity_Goodkid2026,
    meta: { requiresAuth: false,title: '2026 全國閱讀好小子學藝競賽' },
  },
  {
    path: "/Activity_Event",
    name: "Activity_Event",
    component: Activity_InfoGeneric,
    meta: { requiresAuth: false, title: '活動資訊' },
    props: route => ({ eventId: route.query.id })
  },   
  {
    path: "/Activity_CheckLogin",
    name: "Activity_CheckLogin",
    component: Activity_CheckLogin,
    meta: { requiresAuth: false,title: '登入' },
  },  
  {
    path: "/goodkid/Activity_CreateClass",
    name: "Activity_CreateClass",
    component: Activity_CreateClass,
    meta: { requiresAuth: false,title: '全國閱讀好小子學藝競賽'  },
  },
  {
    path: "/Activity_Data",
    name: "Activity_Data",
    component: Activity_Data,
    meta: { requiresAuth: false },
  },
  {
    path: "/:type",
    name: "CatePage",
    component: CatePage,
    meta: { requiresAuth: false },
  },
  //  {
  //   path: "/Activity/:type/:id",
  //   name: "Activity_Info",
  //   component: Activity_Info,
  //   meta: { requiresAuth: false },
  // },
  {
    path: "/content/:type/:id",
    name: "Content",
    component: Content,
    meta: { requiresAuth: false },
  },
  {
    path: "/profile/:id",
    name: "Profile",
    component: Profile,
    meta: { requiresAuth: false },
  },
  {
    path: "/group/:id",
    name: "GroupProfile",
    component: GroupProfile,
    meta: { requiresAuth: false },
  },
  {
    path: "/pack/:id",
    name: "PackContent",
    component: PackContent,
    meta: { requiresAuth: false },
  },
  {
    path: "/setting",
    name: "Setting",
    component: Setting,
    meta: { requiresAuth: true },
  },
  {
    path: "/management",
    name: "Management",
    component: Management,
    meta: { requiresAuth: true },
  },
  {
    path:"/reported",
    name:"Reported",
    component:Reported,
    meta: { requiresAuth: true },
  },
  {
    path: "/mindmaphome",
    name: "MindMapHome",
    component: MindMapHome,
    meta: { requiresAuth: false },
  },
  {
    path: "/mindmap",
    name: "MindMap",
    component: MindMap,
    meta: { requiresAuth: false },
  },
];
const router = createRouter({
  history: createWebHistory(),
  routes,
});
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'HiTeach授權活動平台';
  next();
});

export default router;
